import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { IoArrowBackSharp } from 'react-icons/io5';
import { FormattedMessage, useIntl } from 'react-intl';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import ButtonComponent from '../../components/ButtonComponent';
import InputComponent from '../../components/InputComponent';
import Layout from '../../components/Layout/Layout';
import Toast from '../../helpers/Toast';
import { FileTypeDTO } from '../../models/File/FileTypeDTO';
import { FileTypeService } from '../../services/FileTypeService';

function FileTypeEdit() {
  const { id } = useParams<{ id: string; }>();
  const navigate = useNavigate();
  const intl = useIntl()
  const service = new FileTypeService()
  const [fileType, setFileType] = useState<FileTypeDTO | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const getById = async () => {
      setLoading(true);
      const response = await service.GetById(Number(id));
      if(response.success === false || response.obj === null)
      {
          setLoading(false);
          Toast.Show("error", response.message);
          return;
      }

      setFileType(response.obj);
      setLoading(false);
  }

  const edit = async () => {
      var data : FileTypeDTO = {
          id: Number(id),
          name: fileType != null ? fileType.name : ""
      }

      setLoading(true);
      const response = await service.Edit(data);
      if(response.success === false)
      {
          setLoading(false);
          Toast.Show("error", response.message);
          return;
      }
      setLoading(false);
      navigate(-1);
      Toast.Show("success", "Setting editado com sucesso");
  }

  useEffect(()=> {
      getById();
  }, [])

  return(
      <Layout>
          <div className="pageContainer">
              <div className="pageHeader">
                  <span className="pageTitle">
                      {" "}
                      <IoArrowBackSharp className="pageTitleBackIcon" onClick={() => navigate(-1)} />
                      <FormattedMessage id="Screens.FileType.Title" />:
                  </span>
              </div>
              <div className="pageBody">
                  {loading === true && (
                      <div className="loading">
                          <span>
                              {" "}
                              <FormattedMessage id="Common.Loading.DataLoading" />
                              ...{" "}
                          </span>
                          <CircularProgress style={{ marginLeft: "10px" }} size={"25px"} />
                      </div>
                  )}

                  {loading === false && fileType === null && (
                      <div style={{ color: "#E74C3C" }}>
                          <FormattedMessage id="Screens.FileType.FileTypeDontExist" />
                      </div>
                  )}

                  {loading === false && fileType !== null && (
                  <>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                    <InputComponent
                        xl={4}
                        lg={4}
                        md={5}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={fileType.name}
                        label={intl.formatMessage({
                            id: "Screens.FileType.Info.Name",
                        })}
                        readOnly={loading}
                        onChange={(t: string) => setFileType({...fileType, name: t})}
                    />
                    </Row>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                      <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                          <ButtonComponent
                              style={{ width: '100%', marginTop: '10px' }}
                              text={intl.formatMessage({ id: "FileTypeEdit.Save" })}
                              loading={loading}
                              onClick={() => edit()}
                          />
                      </Col>
                  </Row> 
                  </>
                  )
                  }
              </div>
          </div>
      </Layout>
  );
}

export default FileTypeEdit